import { useState, useEffect } from 'react'

export interface IUseHeaderScrollReturn {
  isMenuOpen: boolean
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
  isCollapsed: boolean
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>
}

export function useHeaderScroll(): IUseHeaderScrollReturn {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(false)

  useEffect(() => {
    let lastScrollY = typeof window !== 'undefined' ? window.scrollY : 0

    const handleScroll = () => {
      const currentScrollY = window.scrollY
      const delta = currentScrollY - lastScrollY

      if (currentScrollY <= 20) {
        setIsCollapsed(false)
      } else if (delta > 5 && currentScrollY > 50) {
        // Scrolling down -> collapse to circular button and close open mobile menu
        setIsCollapsed(true)
        setIsMenuOpen(false)
      } else if (delta < -5) {
        // Scrolling up -> expand back to full width
        setIsCollapsed(false)
      }

      lastScrollY = currentScrollY
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return { isMenuOpen, setIsMenuOpen, isCollapsed, setIsCollapsed }
}

export default useHeaderScroll
